/* @jsx h */
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  h,
  Ref,
  nextTick,
} from "vue";
import {
  Service,
  Category,
  Product,
  CartItem,
  TopProductsDatum,
  TableStatus,
} from "@lemmonhq/types";
import { CartAPI, searchProducts } from "@lemmonhq/orders";
import { api } from "@app/data/api";
import dayjs from "dayjs";
import { TableDetails } from "@app/vue/pages/Tables/TableDetails";
import { useTableDetailsActions } from "@app/vue/pages/Tables/useTableDetailsActions";
import { useLocalization, HapticButton } from "@lemmonhq/uikit";
import { useAuth } from "../../providers/Auth";
import {
  filterServicesBySchedule,
  sortCatalogItems,
} from "@app/utils/clientBusiness";
//
export const cardBgColor = "var(--pos-card-bg)";

const defaultBarColor = "var(--pos-bar-color)";

const ColorBar = defineComponent<{ color?: string }>({
  name: "ColorBar",
  props: ["color"],
  setup(props) {
    return () => {
      const color = props.color || defaultBarColor;
      return (
        <div
          class="absolute top-0 left-[-1px] bottom-0 rounded-tl-lg rounded-bl-lg"
          style={`width: 6px; height: calc(100% - 0); background: ${color};`}
        ></div>
      );
    };
  },
});

export type CatalogBarProps = {
  searchQuery: Ref<string>;
  selectedTable: Ref<TableStatus | undefined>;
  cartAPI: CartAPI;
  verticalLayout: Ref<boolean>;
  onTableUpdated?: () => void;
};
export const CatalogBar = defineComponent<CatalogBarProps>({
  name: "CatalogBar",
  props: [
    "searchQuery",
    "selectedTable",
    "cartAPI",
    "verticalLayout",
    "onTableUpdated",
  ],
  setup(props) {
    const { searchQuery } = props;
    const isSearchExpanded = ref(false);
    const showTableDetails = ref(false);
    const hiddenClass =
      import.meta.env.VITE_ENV === "production" ? "hidden" : "";
    const { t } = useLocalization();
    const tableDetailsActions = useTableDetailsActions({
      getTableStatus: () => props.selectedTable.value,
      onTableUpdated: () => props.onTableUpdated?.(),
    });
    return () => {
      return (
        <div class="mx-0 pt-0 pb-0 lg:pt-2 lg:pb-0 lg:px-3 border-b  flex flex-col items-center gap-2">
          {/* Mobile Search */}
          <div class="lg:hidden flex flex-col w-full pt-2 pb-2 gap-1">
            <div class="flex flex-1 relative gap-2 items-center px-2">
              {isSearchExpanded.value || !props.selectedTable.value ? (
                <label class="input  input-bordered flex items-center gap-2 relative w-full">
                  <span class="absolute left-3 top-1/2 transform -translate-y-1/2  h-5 w-5 flex justify-center items-center">
                    <span class="material-symbols-outlined mr-1 text-2xl">
                      manage_search
                    </span>
                  </span>
                  <input
                    name="search"
                    ref={(el) => {
                      console.log("ref", el, isSearchExpanded.value);
                      if (isSearchExpanded.value) {
                        nextTick(() => {
                          el && (el as HTMLInputElement).focus();
                        });
                      }
                    }}
                    type="text"
                    v-model={searchQuery.value}
                    placeholder={t("pos.cart.search_placeholder")}
                    class="grow pl-6"
                    autofocus={isSearchExpanded.value}
                    onBlur={() => {
                      isSearchExpanded.value = false;
                      if (!searchQuery.value) {
                      }
                    }}
                  />
                </label>
              ) : (
                <>
                  {props.selectedTable.value && (
                    <div class="flex justify-start items-center flex-1 px-1">
                      <button
                        onClick={() => (showTableDetails.value = true)}
                        class={`flex justify-center items-center  gap-1 px-1`}
                      >
                        <span class=" flex justify-center items-center ">
                          <span class="material-symbols-outlined text-1xl">
                            table_restaurant
                          </span>
                        </span>
                        <span class="font-medium">
                          {props.selectedTable.value.table.name}
                        </span>
                      </button>

                      {showTableDetails.value && (
                        <TableDetails
                          isOpen={showTableDetails.value}
                          onClose={() => (showTableDetails.value = false)}
                          tableStatus={props.selectedTable.value}
                          onShowPayment={tableDetailsActions.showPayment}
                          printReceipt={tableDetailsActions.printReceipt}
                          showChangeTableModal={
                            tableDetailsActions.showChangeTableModal
                          }
                          showTransferItemsModal={
                            tableDetailsActions.showTransferItemsModal
                          }
                        />
                      )}
                    </div>
                  )}{" "}
                  <button
                    onClick={() => (isSearchExpanded.value = true)}
                    class="btn btn-circle btn-ghost"
                  >
                    <span class="material-symbols-outlined text-3xl">
                      manage_search
                    </span>
                  </button>
                </>
              )}
              <button
                onClick={() => (props.cartAPI.isAddSeatsModalOpen.value = true)}
                class={`btn w-[38px] h-[38px] btn-neutral p-0 min-h-0`}
              >
                <span class="material-symbols-outlined text-1xl">
                  person_add
                </span>
              </button>
              <button
                onClick={() =>
                  (props.cartAPI.isTableSwitcherOpen.value =
                    !props.cartAPI.isTableSwitcherOpen.value)
                }
                class={`btn w-[38px] h-[38px] p-0 min-h-0 ${
                  props.cartAPI.isTableSwitcherOpen.value
                    ? "btn-primary"
                    : "btn-primary"
                }`}
              >
                <span class="material-symbols-outlined text-1xl">
                  wand_stars
                </span>
              </button>
            </div>
            {props.cartAPI.cart.customers.length > 0 ? (
              <div class="px-2 py-2 flex flex-row gap-2 overflow-x-auto hidden">
                {props.cartAPI.cart.customers.map((customer, i) => {
                  return (
                    <button
                      onClick={() => {
                        if (
                          props.cartAPI.activeCustomerId.value === customer.id
                        ) {
                          props.cartAPI.activeCustomerId.value = undefined;
                        } else {
                          props.cartAPI.activeCustomerId.value = customer.id;
                        }
                      }}
                      class={
                        "btn btn-sm " +
                        (props.cartAPI.activeCustomerId.value === customer.id
                          ? "btn-primary"
                          : "")
                      }
                      key={i}
                    >
                      {customer.name}
                    </button>
                  );
                })}
              </div>
            ) : null}
          </div>

          {/* Desktop Search */}
          <div class="hidden lg:flex flex-1 w-full py-2 space-x-2">
            <div class="flex flex-1">
              <label class="input input-bordered flex items-center gap-2 relative flex-1">
                <span class="absolute left-3 top-1/2 transform -translate-y-1/2  h-5 w-5 flex justify-center items-center">
                  <span class="material-symbols-outlined mr-1 text-3xl">
                    manage_search
                  </span>
                </span>
                <input
                  type="text"
                  v-model={searchQuery.value}
                  placeholder={t("pos.cart.search_placeholder")}
                  class="grow pl-6"
                />
              </label>
            </div>
            <div class="flex justify-center items-center">
              <button
                onClick={() => {
                  const value = !props.verticalLayout.value;
                  props.verticalLayout.value = value;
                  localStorage.setItem(
                    VERTICAL_LAYOUT_LOCAL_STORAGE_KEY,
                    value ? "1" : "",
                  );
                }}
                class={`flex items-center justify-center rounded-lg border transition-all duration-300 cursor-pointer ${
                  props.verticalLayout.value
                    ? "bg-primary/15 border-primary/30 text-primary"
                    : "bg-base-content/5 border-base-content/10 text-base-content/40 hover:text-base-content/60 hover:border-base-content/20"
                }`}
                style="width: 42px; height: 42px;"
                title={
                  props.verticalLayout.value
                    ? "Switch to horizontal"
                    : "Switch to vertical"
                }
              >
                <span
                  class="material-symbols-outlined text-xl transition-transform duration-300"
                  style={{
                    transform: props.verticalLayout.value
                      ? "rotate(0deg)"
                      : "rotate(90deg)",
                  }}
                >
                  splitscreen_left
                </span>
              </button>
            </div>
          </div>

          {/* Table Name Display */}
          {tableDetailsActions.renderModals()}
        </div>
      );
    };
  },
});

export type CatalogProps = {
  services: Service[];
  products: Product[];
  cartItems: CartItem[];
  cartAPI: CartAPI;
  selectedService: Service | null;
  selectedCategory: Category | null;
  onServiceSelect: Function;
  onCategorySelect: Function;
  onProductSelect: Function;
  selectedTable: Ref<TableStatus | undefined>;
  onTableUpdated?: () => void;
};
const VERTICAL_LAYOUT_LOCAL_STORAGE_KEY = "vertical-layout";
export const Catalog = defineComponent<CatalogProps>({
  name: "Catalog",
  props: [
    "services",
    "products",
    "cartItems",
    "selectedService",
    "selectedCategory",
    "onServiceSelect",
    "onCategorySelect",
    "onProductSelect",
    "selectedTable",
    "cartAPI",
    "onTableUpdated",
  ],
  setup(props) {
    const searchQuery = ref("");
    const topProducts = ref<TopProductsDatum[]>([]);
    const topProductsLoading = ref(false);
    const verticalLayout = ref(
      (() => {
        return !!localStorage.getItem(VERTICAL_LAYOUT_LOCAL_STORAGE_KEY);
      })(),
    );
    onMounted(async () => {
      try {
        topProductsLoading.value = true;
        const today = dayjs();
        const range = {
          type: "today" as const,
          startDate: today.subtract(10, "day").format("YYYY-MM-DD"),
          endDate: today.format("YYYY-MM-DD"),
        };
        topProducts.value = (await api.getTopProducts(range)).sort((a, b) => {
          return b.total_count - a.total_count;
        });
        console.log("topProducts", topProducts);
      } catch (error) {
        console.error("Failed to fetch top products:", error);
      } finally {
        topProductsLoading.value = false;
      }
    });

    const filteredProducts = computed(() =>
      searchQuery.value
        ? searchProducts(props.products, searchQuery.value)
        : [],
    );

    const showSearch = computed(() => searchQuery.value.length > 0);

    const availableServices = computed(() =>
      filterServicesBySchedule(props.services),
    );
    const { t } = useLocalization();
    return () => {
      console.log("availableServices", availableServices.value);
      return (
        <>
          <CatalogBar
            searchQuery={searchQuery}
            selectedTable={props.selectedTable}
            cartAPI={props.cartAPI}
            verticalLayout={verticalLayout}
            onTableUpdated={props.onTableUpdated}
          />
          <div
            style={`display: ${verticalLayout.value ? "grid" : "flex"};     grid-template-columns: ${
              props.selectedService ? "250px 250px 1fr;" : "250px 1fr;"
            }`}
            class="flex-1 flex flex-col overflow-y-auto border-r "
          >
            {!showSearch.value && (
              <>
                <div
                  style={`border-right-color: ${verticalLayout.value ? "" : "transparent"}`}
                  class="border-b border-r px-4 py-0 "
                >
                  <h3 class="py-2 text-accent capitalized ">
                    {t("pos.main.services")}
                  </h3>
                  <div
                    data-training="pos.catalog.service-row"
                    class="flex gap-4 overflow-x-auto pb-4"
                    style={`scrollbar-width: thin; display: ${verticalLayout.value ? "grid" : "flex"}`}
                  >
                    {availableServices.value.length === 0 && (
                      <div>{t("pos.catalog.no_services")}</div>
                    )}
                    {availableServices.value.map((service, serviceIndex) => {
                      const isSelected =
                        props.selectedService &&
                        props.selectedService.id == service.id;
                      return (
                        <HapticButton
                          key={service.id}
                          onClick={() => {
                            if (isSelected) {
                              props.onServiceSelect(null);
                            } else {
                              props.onServiceSelect(service);
                            }
                          }}
                          data-selectService={service.name}
                          data-training={
                            serviceIndex === 0
                              ? "pos.catalog.service-first"
                              : undefined
                          }
                          style={`background: ${isSelected ? "var(--pos-card-selected-bg)" : cardBgColor}; color: var(--pos-bar-color); border-color: ${
                            isSelected ? service.color || defaultBarColor : ""
                          }; width: ${verticalLayout.value ? "100%" : ""} `}
                          class="border  text-center rounded-lg flex justify-center items-center flex-shrink-0 cursor-pointer select-none font-semibold px-0 py-3 sm:py-8 h-16 xl:h-20 w-[calc(50%-8px)] md:w-[calc(20%-13px)] relative l-box-shadow"
                        >
                          <ColorBar color={service.color} />
                          {service.name}
                        </HapticButton>
                      );
                    })}
                  </div>
                </div>
                {props.selectedService && (
                  <div
                    style={`border-right-color: ${verticalLayout.value ? "" : "transparent"}`}
                    class="border-b px-4  border-r "
                  >
                    <h3 class="py-2 text-accent capitalized ">
                      {t("pos.main.categories")}
                    </h3>
                    <div
                      data-training="pos.catalog.category-row"
                      class="flex gap-4 overflow-x-auto pb-4"
                      style={`scrollbar-width: thin; display: ${verticalLayout.value ? "grid" : "flex"}`}
                    >
                      {sortCatalogItems(
                        props.selectedService.categories || [],
                      ).map((category) => {
                        const isSelected =
                          props.selectedCategory?.id === category.id;
                        const baseColor =
                          category.color ||
                          props.selectedService?.color ||
                          defaultBarColor;
                        return (
                          <HapticButton
                            key={category.id}
                            data-selectCategory={category.name}
                            onClick={() => props.onCategorySelect(category)}
                            style={`background: ${isSelected ? "var(--pos-card-selected-bg)" : cardBgColor}; color: var(--pos-bar-color); border-color: ${isSelected ? baseColor : ""};
                            width: ${verticalLayout.value ? "100%" : ""}
                           `}
                            class="border text-center rounded-lg flex justify-center items-center flex-shrink-0 cursor-pointer select-none font-semibold w-[calc(50%-10px)] px-0 py-3 xl:py-8 h-16 xl:h-20 md:w-[calc(20%-16px)] relative"
                          >
                            <ColorBar color={baseColor} />
                            {category.name}
                          </HapticButton>
                        );
                      })}
                    </div>
                  </div>
                )}
              </>
            )}

            <div
              class={`flex-1 px-4 pt-2 pb-24 ${verticalLayout.value ? "bg-base-200" : ""}`}
            >
              {!showSearch.value && !props.selectedService ? (
                <div
                  style={`border-right-color: ${verticalLayout.value ? "" : "transparent"}`}
                  class="mb-6 pr-0 "
                >
                  <h3 class="mb-2 text-base-content flex justify-start items-center">
                    {t("pos.main.top_products")}{" "}
                    {topProductsLoading.value ? (
                      <span class="ml-2 loading loading-xs"></span>
                    ) : null}
                  </h3>
                  <div
                    style={`scrollbar-width: thin; display: ${verticalLayout.value ? "grid" : "flex"}`}
                    class="flex flex-wrap gap-4 grid-cols-3 "
                  >
                    {topProducts.value.slice(0, 10).map((topProduct) => {
                      const product = props.products.find(
                        (p) => p.id === topProduct.product.id,
                      );
                      if (!product) return null;
                      return (
                        <ProductCard
                          key={product.id}
                          product={product}
                          cartItems={props.cartItems}
                          onProductSelect={props.onProductSelect}
                          cartAPI={props.cartAPI}
                          verticalLayout={verticalLayout}
                        />
                      );
                    })}
                  </div>
                </div>
              ) : (
                <>
                  <h3 class="pb-2 text-accent capitalized hidden">
                    {t("nav.core.products")}
                  </h3>

                  <div
                    style={`scrollbar-width: thin; display: ${verticalLayout.value ? "grid" : "flex"}`}
                    class="flex flex-wrap gap-4 grid-cols-2"
                  >
                    {showSearch.value
                      ? filteredProducts.value.map((product) => (
                          <ProductCard
                            key={product.id}
                            product={product}
                            cartItems={props.cartItems}
                            onProductSelect={props.onProductSelect}
                            cartAPI={props.cartAPI}
                            verticalLayout={verticalLayout}
                          />
                        ))
                      : props.selectedCategory &&
                        props.selectedCategory?.product_ids
                          .map(
                            (el) =>
                              props.products.find(
                                (p) => p.id === el,
                              ) as Product,
                          )
                          .filter((el) => el as Product)
                          .map((product, productIndex) => (
                            <ProductCard
                              key={product.id}
                              product={product}
                              cartItems={props.cartItems}
                              cartAPI={props.cartAPI}
                              onProductSelect={props.onProductSelect}
                              verticalLayout={verticalLayout}
                              trainingAttr={
                                productIndex === 0
                                  ? "pos.catalog.product-first"
                                  : undefined
                              }
                              color={
                                props.selectedCategory?.color
                                  ? props.selectedCategory.color
                                  : props.selectedService?.color
                              }
                            />
                          ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      );
    };
  },
});

export type ProductCardProps = {
  product: Product;
  cartItems: CartItem[];
  onProductSelect: Function;
  color?: string;
  cartAPI: CartAPI;
  verticalLayout: Ref<boolean>;
  trainingAttr?: string;
};
const ProductCard = defineComponent<ProductCardProps>({
  name: "ProductCard",
  props: [
    "product",
    "cartItems",
    "onProductSelect",
    "color",
    "cartAPI",
    "verticalLayout",
    "trainingAttr",
  ],
  setup(props) {
    const auth = useAuth();
    const selectedCartItem = computed(() => {
      let items = props.cartAPI.cart.items.filter(
        (el) => el.productId === props.product.id,
      );
      if (props.cartAPI.activeCustomerId.value) {
        items = items.filter(
          (el) => el.customerId === props.cartAPI.activeCustomerId.value,
        );
      }
      return items.reduce((sum, el) => sum + el.quantity, 0);
    });

    return () => {
      const color = props.product.color || props.color || defaultBarColor;
      return (
        <HapticButton
          onClick={() => props.onProductSelect(props.product)}
          data-selectProduct={props.product.name}
          data-training={props.trainingAttr}
          style={
            selectedCartItem.value > 0
              ? {
                  background: "var(--pos-card-selected-bg)",
                  borderColor: color,
                  color: "var(--pos-bar-color)",
                  width: props.verticalLayout.value ? "100%" : "",
                }
              : {
                  background: cardBgColor,
                  color: "var(--pos-bar-color)",
                  width: props.verticalLayout.value ? "100%" : "",
                }
          }
          class={
            "rounded-lg border p-4 shadow-sm select-none cursor-pointer  relative w-[calc(50%-8px)] md:w-[calc(20%-13px)] h-16 lg:h-20 text-xs select-none relative flex items-center l-box-shadow"
          }
          data-price={props.product.price}
        >
          <ColorBar color={color} />
          <h3 class="font-medium overflow-hidden">{props.product.name}</h3>
          <p class="mt-2 font-semibold hidden">
            {auth.user.value?.restaurant.currency || "CHF"}{" "}
            {props.product.price}
          </p>

          {selectedCartItem.value > 0 && (
            <div class="absolute right-2 bottom-2">
              <div
                style={{ fontSize: "9px" }}
                class="rounded text-center flex justify-center items-center border border-base-content bg-base-100 text-base-content w-3.5 h-3.5 text-xs"
              >
                {selectedCartItem.value}
              </div>
            </div>
          )}
        </HapticButton>
      );
    };
  },
});
